import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedElement,
  updateSelectedInteraction,
} from "../../../app/slices/TrainingSlice";
import { ISetOutfit } from "../../../models/interactions/SetOutfit";
import ActorPropDropdown from "../lookat/ActorPropDropdown";
import PiInteractionStringDropdown from "../../../components/PiInteractionStringDropdown";
import { useEffect, useState } from "react";

interface Outfit {
  outfit_name: string;
  outfit_preview_male: string;
}

export default function SetOutfitPreviewBody() {
  const dispatch = useDispatch();
  const interaction = useSelector(selectSelectedElement) as ISetOutfit;
  const [outfits, setOutfits] = useState<Outfit[]>([]);

  useEffect(() => {
    // Load outfits from JSON file
    fetch("/outfits/Outfits.json")
      .then((response) => response.json())
      .then((data) => setOutfits(data))
      .catch((error) => console.error("Error loading outfits:", error));
  }, []);

  const updateInteraction = (field: keyof ISetOutfit, value: any) => {
    dispatch(updateSelectedInteraction({ ...interaction, [field]: value }));
  };

  const actorDropdown = (
    <ActorPropDropdown
      label="Target"
      onClick={(id) => updateInteraction("actorId", id)}
      selectedObjectId={interaction.actorId}
    />
  );

  const outfitNames = outfits.map((outfit) => outfit.outfit_name);

  const outfitDropdown = (
    <PiInteractionStringDropdown
      label="Outfit"
      items={outfitNames}
      selectedItem={interaction.outfitName || "Select an outfit"}
      onClick={(outfitName) => updateInteraction("outfitName", outfitName)}
    />
  );

  return (
    <div className="flex flex-col w-full h-full gap-[12px]">
      {actorDropdown}
      {outfitDropdown}
    </div>
  );
}
